import {
	SET_AUTH
} from "../../actions";

const INITIAL_STATE = {
	model: {}
};

export default (state = INITIAL_STATE, action) => {

	switch(action.type) {
		case SET_AUTH: return {...state, model: action.data };

		default: return state;
	}
};


// WEBPACK FOOTER //
// src/reducers/lib/authReducer.js